import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = ({ isDarkMode }) => {
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language?.startsWith('es') ? 'es' : 'en';

  useEffect(() => {
    document.documentElement.lang = currentLang;
  }, [currentLang]);

  const setLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  const segmentClass = (lang) => {
    const isActive = currentLang === lang;
    if (isActive) {
      return isDarkMode
        ? 'bg-gradient-to-r from-purple-600 to-purple-700 text-white shadow-lg shadow-purple-500/25'
        : 'bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg shadow-blue-500/25';
    }
    return isDarkMode
      ? 'text-gray-300 hover:text-white hover:bg-gray-700/50'
      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-200/80';
  };

  return (
    <div
      className="fixed right-4 z-[60]"
      style={{ bottom: 'max(1rem, env(safe-area-inset-bottom))' }}
    >
      <div
        className={`inline-flex rounded-2xl p-1 backdrop-blur-md border shadow-xl transition-all duration-300 ${
          isDarkMode
            ? 'bg-gray-800/70 border-gray-700/50 shadow-black/20'
            : 'bg-white/80 border-gray-200/80 shadow-gray-200/50'
        }`}
        role="group"
        aria-label={currentLang === 'en' ? t('languageSwitcher.switchToSpanish') : t('languageSwitcher.switchToEnglish')}
      >
        <button
          type="button"
          onClick={() => setLanguage('en')}
          aria-pressed={currentLang === 'en'}
          aria-label={t('languageSwitcher.switchToEnglish')}
          className={`min-w-[44px] min-h-[44px] px-4 py-2 rounded-xl text-sm font-semibold tracking-wide transition-all duration-300 ${segmentClass('en')}`}
        >
          {t('languageSwitcher.english')}
        </button>
        <button
          type="button"
          onClick={() => setLanguage('es')}
          aria-pressed={currentLang === 'es'}
          aria-label={t('languageSwitcher.switchToSpanish')}
          className={`min-w-[44px] min-h-[44px] px-4 py-2 rounded-xl text-sm font-semibold tracking-wide transition-all duration-300 ${segmentClass('es')}`}
        >
          {t('languageSwitcher.spanish')}
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
